// frontend/src/components/public/PortfolioHeader.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';

interface PortfolioHeaderProps {
  logo?: string;
  portfolioTitle?: string;
  contactName?: string; // 👈 add this
  theme?: {
    primaryColor: string;
    accentColor: string;
  };
}

const PortfolioHeader: React.FC<PortfolioHeaderProps> = ({ logo, portfolioTitle, contactName, theme }) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
background: 'linear-gradient(90deg, #4CA1AF 0%, #2C3E50 100%)',        
borderBottom: '1px solid #e0e0e0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        transition: 'all 0.3s ease'
      }}
    >
      <Box
        sx={{
          maxWidth: '1400px',
          mx: 'auto',
          px: { xs: 3, md: 6 },
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        {/* Logo */}
        {logo && (
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              maxHeight: 60,
              maxWidth: 200,
              objectFit: 'contain',
              cursor: 'pointer'
            }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
        )}

{/* Portfolio Title */}
{portfolioTitle && (
  <Typography
    variant="h3"
    sx={{
      fontSize: '2.5rem',
      fontWeight: 600,
      color: theme?.primaryColor || '#000',
      textAlign: 'right',
      flexGrow: 1,
      ml: logo ? 3 : 0
    }}
  >
    {portfolioTitle}
    {contactName && (
      <>
        <Typography
          component="span"
          sx={{
            fontWeight: 400,
            fontSize: '1.5rem',
            color: '#e0e0e0',
            ml: 1,
          }}
        >
          {' '}&nbsp;prepared for &nbsp;
        </Typography>
        <Typography
          component="span"
          sx={{
            fontWeight: 400,
            fontSize: '1.5rem',
            color: theme?.primaryColor || '#000',
          }}
        >
          {contactName}
        </Typography>
      </>
    )}
  </Typography>
)}
      </Box>
    </Box>
  );
};

export default PortfolioHeader;